import loaderSvg from '../../assets/images/round-loader.svg'

function RoundLoader({ className }) {
    return (
        <img src={loaderSvg} className={className} alt="" />
    )
}

export default RoundLoader
